module.exports = __webpack_public_path__ + "./Bryan_pbw_ac12141805844c11c7b6227956cc22c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Bryan_pbw.png
// module id = 587
// module chunks = 0